import React, {Component} from 'react';
import {Card, CardBody, CardTitle, Col, Row} from 'reactstrap';
import {Colxx} from "../../../components/common/CustomBootstrap";
import IconCard from "../../../components/cards/IconCard";
import {i18nizeDate, numberWithCommas} from "../../../helpers/Utils";
import {withTranslation} from "react-i18next";
import Api from '../../../services/Api';
import Boards from "./boards";
import moment from "moment";

class Stats extends Component {
  constructor(props) {
    super(props);
    this.state = {
      status: null,
    }
  }

  async componentDidMount() {
    await this.fetchData();
  }

  fetchData = async () => {
    const {match} = this.props;
    const {id} = match.params;
    try {
      const {data} = await Api.invoke('GET', `/v2/admin-ui/boards/${id}/status`);
      this.setState({
        status: data,
      });
    } catch (e) {
      console.log("error: ", e);
    }
  };

  getActivityDuration = () => {
    const {status} = this.state;
    const {location} = this.props;
    const {endTime, startTime} = location.state;
    if (!status.active) {
      return moment(endTime).diff(moment(startTime), 'days');
    }
    return moment().diff(moment(startTime), 'days');
  };

  render() {
    const {status} = this.state;
    const {t, match} = this.props;
    const {id} = match.params;
    return (
      <Row>
        <Colxx xxs="12" className="mb-5">
          <Card className="h-100">
            <CardBody>
              <CardTitle className="text-large text-primary mb-5">
                {`${t('Campaign Stats')} (${id})`}
              </CardTitle>
              <Row>
                <Col className='col-12 col-md-4 col-lg-4'>
                  <IconCard
                    icon="icon-Business-Mens"
                    title={t('Campaign Users')}
                    value={status ? numberWithCommas(status.numUsers) : null}
                  />
                </Col>
                <Col className='col-12 col-md-4 col-lg-4'>
                  <IconCard
                    icon="icon-Bar-Chart3"
                    title={t('Highest Score')}
                    value={status ? numberWithCommas(status.maximumScore) : null}
                  />
                </Col>
                <Col className='col-12 col-md-4 col-lg-4'>
                  <IconCard
                    icon="icon-Bar-Chart3"
                    title={t('Lowest Score')}
                    value={status ? numberWithCommas(status.minimumScore) : null}
                  />
                </Col>
                <Col className='col-12 col-md-4 col-lg-4'>
                  <IconCard
                    icon="icon-Mail-2"
                    title={t('Notifications Count')}
                    value={status ? numberWithCommas(status.numNotifications) : null}
                  />
                </Col>
                <Col className='col-12 col-md-4 col-lg-4'>
                  <IconCard
                    icon="icon-Stopwatch"
                    title={t('Activity days')}
                    value={status ? this.getActivityDuration() : null}
                  />
                </Col>
                <Col className='col-12 col-md-4 col-lg-4'>
                  <IconCard
                    icon="icon-Stopwatch"
                    title={t('Last update')}
                    value={status ? i18nizeDate(status.lastUpdate) : null}
                  />
                </Col>
              </Row>
              <Boards id={id}/>
            </CardBody>
          </Card>
        </Colxx>
      </Row>
    );
  }
}

export default withTranslation()(Stats);
